import { render, staticRenderFns } from "./KTableGridItem.vue?vue&type=template&id=f22c9e54&scoped=true"
import script from "./KTableGridItem.vue?vue&type=script&lang=js"
export * from "./KTableGridItem.vue?vue&type=script&lang=js"
import style0 from "./KTableGridItem.vue?vue&type=style&index=0&id=f22c9e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22c9e54",
  null
  
)

export default component.exports